import { defineAsyncComponent } from 'vue'
export default {
  authentication: defineAsyncComponent(() => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/layouts/authentication.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/layouts/default.vue").then(m => m.default || m)),
  support: defineAsyncComponent(() => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/layouts/support.vue").then(m => m.default || m))
}